import {
	Column,
	CreateDateColumn,
	DeleteDateColumn,
	JoinColumn,
	ManyToOne,
	PrimaryGeneratedColumn,
	UpdateDateColumn,
} from 'typeorm';
import type { UserEntity } from './user.entity';

export abstract class BaseEntity<TIdType = number> {
	public constructor(data?: Partial<BaseEntity<TIdType>>) {
		if (data == null) {
			return;
		}

		if (data.id != null) {
			this.id = data.id;
		}

		if (data.createdDate != null) {
			this.createdDate = data.createdDate;
		}

		if (data.modifiedDate != null) {
			this.modifiedDate = data.modifiedDate;
		}

		if (data.deletedDate != null) {
			this.deletedDate = data.deletedDate;
		}

		if (data.ownerUserId != null) {
			this.ownerUserId = data.ownerUserId;
		}

		if (data.creatorUserId != null) {
			this.creatorUserId = data.creatorUserId;
		}

		if (data.modifiedUserId != null) {
			this.modifiedUserId = data.modifiedUserId;
		}

		if (data.deletedUserId != null) {
			this.deletedUserId = data.deletedUserId;
		}
	}

	@PrimaryGeneratedColumn({ name: '_id', unsigned: true })
	public id!: TIdType;

	@Column({
		type: 'int',
		name: '_owner_userId',
		nullable: true,
		unsigned: true,
	})
	public ownerUserId?: number;

	@CreateDateColumn({
		name: '_created_date',
		nullable: false,
		precision: 0,
		default: () => 'CURRENT_TIMESTAMP',
	})
	public createdDate!: Date;

	@Column({
		type: 'int',
		name: '_creator_userId',
		nullable: true,
		unsigned: true,
	})
	public creatorUserId?: number;

	@UpdateDateColumn({
		name: '_modified_date',
		nullable: false,
		precision: 0,
		default: () => 'CURRENT_TIMESTAMP',
		onUpdate: 'CURRENT_TIMESTAMP',
	})
	public modifiedDate!: Date;

	@Column({
		type: 'int',
		name: '_modified_userId',
		nullable: true,
		unsigned: true,
	})
	public modifiedUserId?: number;

	@DeleteDateColumn({ name: '_deleted_date', precision: 0, nullable: true })
	public deletedDate?: Date | null;

	@Column({
		type: 'int',
		name: '_deleted_userId',
		nullable: true,
		unsigned: true,
	})
	public deletedUserId?: number | null;

	// String-based reference avoids circular import (UserEntity extends BaseEntity)
	// FK references _workd__user__id, not the user table's _id primary key
	@ManyToOne('UserEntity', {
		nullable: true,
		createForeignKeyConstraints: false,
	})
	@JoinColumn([{ name: '_owner_userId', referencedColumnName: 'workdUserId' }])
	public owner?: UserEntity | null;

	// String-based reference avoids circular import (UserEntity extends BaseEntity)
	// FK references _workd__user__id, not the user table's _id primary key
	@ManyToOne('UserEntity', {
		nullable: true,
		createForeignKeyConstraints: false,
	})
	@JoinColumn([
		{ name: '_creator_userId', referencedColumnName: 'workdUserId' },
	])
	public creator?: UserEntity | null;

	// String-based reference avoids circular import (UserEntity extends BaseEntity)
	// FK references _workd__user__id, not the user table's _id primary key
	@ManyToOne('UserEntity', {
		nullable: true,
		createForeignKeyConstraints: false,
	})
	@JoinColumn([
		{ name: '_modified_userId', referencedColumnName: 'workdUserId' },
	])
	public modifier?: UserEntity | null;

	// String-based reference avoids circular import (UserEntity extends BaseEntity)
	// FK references _workd__user__id, not the user table's _id primary key
	@ManyToOne('UserEntity', {
		nullable: true,
		createForeignKeyConstraints: false,
	})
	@JoinColumn([
		{ name: '_deleted_userId', referencedColumnName: 'workdUserId' },
	])
	public deleter?: UserEntity | null;
}
